<template>
  <div>
    <div class="header_cust" :style="{ 'background': '#' + color }">
      <avatar-header :src="headerUrl"></avatar-header>
      <div style="color:#fff;font-size:14px;padding-left:8px">{{ channelname }}</div>
    </div>
    <div class="current-conversation-wrapper" :style="androidHeight">
      <div class="current-conversation" :style="androidHeight" @scroll="onScroll">
        <div class="content" :style="contentMb" @touchstart="onTouchStart">
          <div class="message-list" ref="message-list" @scroll="this.onScroll">
            <div class="more" v-if="!isCompleted">
              <el-button type="text" @click="$store.dispatch('getSessionList')">查看历史会话</el-button>
            </div>
            <div class="no-more" v-else>没有更多了</div>
            <message-item v-for="(message, index) in currentMessageList" :message="message" :key="index" />
          </div>
          <div v-show="isShowScrollButtomTips" class="newMessageTips" @click="scrollMessageListToButtom">回到最新位置</div>
          <div v-if="importState" style="padding: 5px 24px;position:absolute;left:2px;bottom:2px;">对方正在输入...</div>
        </div>
        <div class="footer">
          <message-send-box />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import MessageSendBox from '../message/message-send-box'
import MessageItem from '../message/message-item'
import AvatarHeader from '../../pc/avatarHeader'
export default {
  name: 'CurrentConversation',
  components: {
    MessageSendBox,
    MessageItem,
    AvatarHeader
  },
  data() {
    return {
      isShowScrollButtomTips: false,
      preScrollHeight: 0,
      timeout: '',
      contentMb: '',
      androidHeight:''
    }
  },
  created() {
    if (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('iPhone') > -1) {
      this.androidHeight = 'height:calc( 100vh - 60px )'
    } else {
      this.androidHeight = 'height:calc( 100vh - 60px )'
    }
  },
  computed: {
    ...mapState({
      currentMessageList: state => state.conversation.currentMessageList,
      isCompleted: state => state.conversation.isCompleted,
      importState: state => state.user.importState,
      channelname: state => state.conversation.channelname,
      headerUrl: state => state.conversation.headerUrl,
    }),
    ...mapGetters(['toAccount', 'hidden']),
    name() {
      return '智慧客服'
    },
  },
  mounted() {
    this.$bus.$on('image-loaded', this.onImageLoaded)
    this.$bus.$on('scroll-bottom', this.scrollMessageListToButtom)
    /*let doc = document,
        self = window,
        height = self.innerHeight
    // doc.getElementsByClassName('current-conversation-wrapper')[0].style.height = height+'px'
    doc.getElementsByClassName('current-conversation')[0].style.height = height+'px'
    self.addEventListener('resize', function(){
        console.log('resize')
        // doc.getElementsByClassName('current-conversation-wrapper')[0].style.height = height+'px'
        doc.getElementsByClassName('current-conversation')[0].style.height = height+'px'
    })*/
  },
  updated() {
    this.keepMessageListOnButtom()
  },
  methods: {
    onScroll({ target: { scrollTop, scrollHeight } }) {
      let messageListNode = this.$refs['message-list']
      if (!messageListNode) {
        return
      }
      if (this.preScrollHeight - messageListNode.clientHeight - scrollTop < 46) {
        this.isShowScrollButtomTips = false
      }
      //不给页面滑动到顶部和底部 防止触发浏览器外部滑动
      if (scrollTop === 0) {
        messageListNode.scrollTop = 1
      }
      if (messageListNode.scrollHeight - messageListNode.clientHeight == scrollTop) {
        messageListNode.scrollTop = scrollTop - 1
      }
    },
    onTouchStart() {
      this.$bus.$emit('hideKeyboard')
    },
    // 如果滚到底部就保持在底部，否则提示是否要滚到底部
    keepMessageListOnButtom() {
      let messageListNode = this.$refs['message-list']
      if (!messageListNode) {
        return
      }
      // 距离底部20px内强制滚到底部,否则提示有新消息
      if (this.preScrollHeight - messageListNode.clientHeight - messageListNode.scrollTop < 46) {
        this.$nextTick(() => {
          messageListNode.scrollTop = messageListNode.scrollHeight
        })
        this.isShowScrollButtomTips = false
      } else {
        this.isShowScrollButtomTips = true
      }
      this.preScrollHeight = messageListNode.scrollHeight
    },
    // 直接滚到底部
    scrollMessageListToButtom() {
      this.$nextTick(() => {
        let messageListNode = this.$refs['message-list']
        if (!messageListNode) {
          return
        }
        messageListNode.scrollTop = messageListNode.scrollHeight
        this.preScrollHeight = messageListNode.scrollHeight
        this.isShowScrollButtomTips = false
      })
    },
    onImageLoaded() {
      this.keepMessageListOnButtom()
    }
  }
}
</script>
<style lang="stylus" scoped>
/* 当前会话的骨架屏 */
.header_cust{
  background  #000000
  box-shadow 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
  height 60px
  padding-left 20px
  display flex
  align-items center
  @media screen and (max-width: 924px) {
    width 100vw
  }
  @media screen and (min-width: 925px) {
    width 44vw
  }
}
.current-conversation-wrapper
  height $height
  width $width
  background-color $background-light
  color $base
  display flex
  .current-conversation
    display: flex;
    flex-direction: column;
    width: 100%;
    height: $height;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  .profile
    height: $height;
    overflow-y: scroll;
    width 220px
    border-left 1px solid $border-base
    flex-shrink 0
  .more
    display: flex;
    justify-content: center;
    font-size: 12px;
  .no-more
    display: flex;
    justify-content: center;
    color: $secondary;
    font-size: 12px;
    padding: 10px 10px;
.header
  border-bottom 1px solid $border-base
  height 50px
  position relative
  .name
    padding 0 20px
    color $base
    font-size 18px
    font-weight bold
    line-height 50px
    text-shadow $font-dark 0 0 0.1em
    text-align: center
  .btn-more-info
    position absolute
    top 10px
    right -15px
    border-radius 50%
    width 30px
    height 30px
    cursor pointer
    &::before
      position absolute
      right 0
      z-index 0
      content ""
      width: 15px
      height: 30px
      border: 1px solid $border-base
      border-radius: 0 100% 100% 0/50%
      border-left: none
      background-color $background-light
    &::after
      content ""
      width: 8px;
      height: 8px;
      transition: transform 0.8s;
      border-top: 2px solid $secondary;
      border-right: 2px solid $secondary;
      float:right;
      position:relative;
      top: 11px;
      right: 8px;
      transform:rotate(45deg)
    &.left-arrow
      transform rotate(180deg)
      &::before
        background-color $white
    &:hover
      &::after
        border-color $light-primary
.content
  display: flex;
  flex 1 1 auto
  flex-direction: column;
  //height: 100%;
  overflow: hidden;
  height calc(100vh - 60px)
  max-height calc(100vh - 60px)
  position: sticky;
  top 0
  .message-list
    width: 100%;
    height 100%
    box-sizing: border-box;
    overflow-y: scroll;
    padding: 0 8px;
    -webkit-overflow-scrolling: touch;
  .newMessageTips
    position: absolute
    cursor: pointer;
    padding: 5px;
    width: 120px;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 5px;
    font-size: 12px;
    text-align: center;
    border-radius: 10px;
    border: $border-light 1px solid;
    background-color: $white;
    color: $primary;
.footer
  border-top: 1px solid $border-base;/*no*/
  background $white
  flex 0 0 auto
  min-height 66px
  position: sticky
  bottom 0
.show-more {
  text-align: right;
  padding: 10px 20px 0 0;
}
</style>